import Paginator from  './paginator';

export default Paginator;
